export default __webpack_public_path__ + "static/miracle-mask-desktop-1b071b8c769ad599d9830513fd3a32f9.mp4";